<template>
  <div>
    <SubNavigation
      class="navbar__sub-navigation"
      v-if="!isInAppRoute || isInPromoRoute"
    />
    <SubscriptionBar v-if="isInAppRoute" />

    <div
      class="navbar__content navbar__content--small-padding"
      v-show="hasTeleportedContent"
      id="navbar-custom-header"
    />

    <div
      :class="['navbar__content', { 'navbar__content--single-button': isAuthorized && !isInAppRoute, 'navbar__content--two-buttons': isAuthorized && isInAppRoute }]"
      v-if="!hasTeleportedContent"
    >
      <a
        href="/"
        v-if="!isAuthorized"
      >
        <img
          :src="require(`~/images/logo/fakturaonline-logo-${$i18n.locale}.svg`)"
          class="navbar__logo"
          :width="$t('navigation.logoWidth')"
          :height="$t('navigation.logoHeight')"
          :alt="$t('navigation.logoAlt')"
        >
        <img
          :src="require(`~/images/logo/fakturaonline-square-logo-${$i18n.locale}.svg`)"
          class="navbar__logo navbar__logo--mobile"
          width="48"
          height="48"
          :alt="$t('navigation.logoAlt')"
        >
      </a>

      <NavigationLinks class="hidden-md-down" />

      <ul class="navbar-buttons">
        <li v-if="isAuthorized && !isInAppRoute">
          <router-link
            :to="{ name: PATH_DASHBOARD }"
          >
            <Button
              icon="icon icon-dashboard-line"
              type="warning"
              new-design
              size="large"
            >
              {{ $t('navigation.backToApp') }}
            </Button>
          </router-link>
        </li>
        <li
          v-else
          class="navbar-buttons__button"
        >
          <CreateInvoiceButton />
        </li>
        <li
          v-if="!isAuthorized"
          class="navbar-buttons__button hidden-md-down"
        >
          <LoginButton />
        </li>
        <li
          v-if="!isAuthorized || isInAppRoute"
          class="navbar-buttons__button hidden-md-up"
        >
          <NavbarMenu />
        </li>
      </ul>
    </div>
    <Dialogs />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  PATH_ROOT,
  PATH_DASHBOARD,
} from '~/router';

import { isInAppRoute, isPostsRoute, isInPromoRoute } from '~/lib/routerHelper';

import CreateInvoiceButton from '../header/CreateInvoiceButton.vue';
import LoginButton from '../header/LoginButton.vue';
import NavbarMenu from './NavbarMenu.vue';
import NavigationLinks from './NavigationLinks.vue';

export default {
  components: {
    CreateInvoiceButton,
    LoginButton,
    NavbarMenu,
    NavigationLinks,
    SubscriptionBar: () => import(/* webpackChunkName: "navigation" */ '~/modules/SubscriptionBar.vue'),
    Dialogs: () => import(/* webpackChunkName: "navigation" */ '~/modules/Dialogs.vue'),
    SubNavigation: () => import('./SubNavigation.vue'),
  },
  data: () => ({
    PATH_ROOT,
    PATH_DASHBOARD,
    hasTeleportedContent: false,
  }),
  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
    ]),
    isInAppRoute,
    isPostsRoute,
    isInPromoRoute,
  },
  mounted() {
    this.$emitter.on('element-teleported', (value) => { this.hasTeleportedContent = value; });
  },
  beforeDestroy() {
    this.$emitter.off('element-teleported');
  },
};
</script>

<style lang="scss" scoped>
.navbar__sub-navigation {
  @media only screen and (max-width: $--md - 1) {
    display: none;
  }
}

.navbar__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap !important;
  padding-top: 16px;
  padding-bottom: 16px;

  @media only screen and (max-width: $--md - 1) {
    padding: 12px;
  }

  @media only screen and (max-width: $--sm - 1) {
    padding: 8px 12px;
  }

  @media only screen and (max-width: $--xs - 1) {
    padding: 8px 6px;
  }

  &--single-button {
    justify-content: flex-end;

    @media only screen and (max-width: $--sm - 1) {
      justify-content: center;
    }
  }

  &--two-buttons {
    @media only screen and (max-width: $--md - 1) {
      justify-content: flex-end;
    }
  }

  &--small-padding {
    min-height: 72px;
    padding-top: 3px;
    padding-bottom: 3px;

    @media only screen and (max-width: $--md - 1) {
      min-height: 64px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
}

.navbar__logo {
  display: block;
  max-width: 260px;

  @media only screen and (max-width: $--new-navbar-breakpoint) {
    max-width: 164px;
    display: none;
  }

  &--mobile {
    display: block;

    @media only screen and (min-width: ($--new-navbar-breakpoint + 1px)) {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.navbar-buttons {
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.navbar-buttons__button {
  padding-left: 12px;

  @media only screen and (max-width: $--xs - 1) {
    padding-left: 4px;
  }
}
</style>
